(function (window, document, $) {
  $(document).bind('gform_post_render', function () {
    const inputPhones = document.querySelectorAll('.ginput_container_phone');

    if (!inputPhones.length) {
      return;
    }

    let preferredCountries = [];
    const language = $('html').attr('lang');
    switch (language) {
      case 'fr':
        preferredCountries = [
          'fr',
          'be',
          'ch',
          'de',
          'gb',
          'es',
          'it',
          'nl',
          'dk',
          'at',
          'pt',
          'us',
          'ca',
          'lu',
          'pt',
        ];
        break;
      case 'de':
        preferredCountries = [
          'de',
          'at',
          'ch',
          'gb',
          'es',
          'it',
          'fr',
          'be',
          'nl',
          'dk',
          'at',
          'pt',
          'us',
          'ca',
          'lu',
          'pt',
        ];
        break;
      default:
        preferredCountries = [
          'gb',
          'de',
          'ch',
          'es',
          'it',
          'fr',
          'be',
          'nl',
          'dk',
          'at',
          'pt',
          'us',
          'ca',
          'lu',
          'pt',
        ];
    }

    const errorMap =
      language == 'fr'
        ? ['Numéro incorrect', 'Code pays incorrect', 'Trop court', 'Trop long', 'Numéro incorrect']
        : ['Invalid number', 'Invalid country code', 'Too short', 'Too long', 'Invalid number'];
    const initialCountry = language === 'en' ? 'gb' : (language ?? 'fr');

    inputPhones.forEach((inputPhone) => {
      const field = inputPhone.querySelector('input');
      const iti = window.intlTelInput(field, {
        utilsScript: '/wp-content/themes/tiptoe/assets/js/vendors/phone-validator/utils.js',
        preferredCountries,
        initialCountry,
      });

      const phoneCountryField = document.createElement('input');
      phoneCountryField.type = 'hidden';
      phoneCountryField.name = `phone_country_${field.name}`;
      phoneCountryField.value = initialCountry;

      inputPhone.append(phoneCountryField);

      const reset = function () {
        field.classList.remove('is-valid');
        phoneError.style.display = 'none';
        phoneError.innerHTML = '';
      };

      $('<div/>', {
        id: 'phone-check',
        class: 'parsley-errors-list',
      }).appendTo($(inputPhone));
      const phoneError = inputPhone.querySelector('#phone-check');

      field.addEventListener(
        'blur',
        function () {
          reset();
          if (field.value.trim()) {
            if (iti.isValidNumber()) {
              phoneError.style.display = 'none';
              field.classList.add('is-valid');
              field.value = intlTelInputUtils.formatNumber(
                field.value,
                iti.getSelectedCountryData().iso2.toString(),
                intlTelInputUtils.numberFormat.INTERNATIONAL,
              );
            } else {
              const errorCode =
                iti.getValidationError() === -99 ? 0 : this.iti.getValidationError();
              phoneError.innerHTML = errorMap[errorCode];
              phoneError.style.display = 'block';
            }
          }
        }.bind(this),
      );

      field.addEventListener('change', reset);
      field.addEventListener('keyup', reset);
      field.addEventListener('keyup', () => {
        const flag = inputPhone.querySelector('.iti__flag');

        if (!flag) {
          return;
        }

        const classes = flag.getAttribute('class').split(' ');
        if (classes.length < 2) {
          return;
        }

        phoneCountryField.value = classes[1].replace('iti__', '');
      });
    });
  });
})(window, document, jQuery);
